import React, { useState } from "react";
import MobileHeader from "../../layout/MobileHeader";
import MobileHeaderSearch from "../../components/MobileHeaderSearch";
import Icon from "../../components/Icon";

import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import Container from "../../layout/Container";
import Hotel from "../../assets/images/card/property.png";
import OfferCard from "../../components/cards/OfferCard";

import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import RazorPay from "../../components/RazorPay";
import LoginPopup from "../../components/LoginPopup";

import Loader from "../../components/elements/Loader";
import { bookProperty } from "../../apis";
import { dateFormat } from "../../utils";

const ConfirmPay = ({ hotel = {}, room = {} }) => {

  const { isLoggedIn, customer } = useSelector( state => state.auth )
  const searchParams = useSearchParams();
  const [ isLogin, setIsLogin ] = useState(false)
  const [ isSubmitting, setIsSubmitting ] = useState(false)
  const [ razorpay, setRazorpay ] = useState({ amountToPay: 0, bookingId: null, orderId: null, open: false })

  const roomId = searchParams[0].get("roomId");
  const hotelId = searchParams[0].get("hotelId");
  const guest = searchParams[0].get("guest");
  const checkInDate = searchParams[0].get("checkInDate");
  const checkOutDate = searchParams[0].get("checkOutDate");

  const bookhotel = async () => {
    try {
      if( !isLoggedIn ) return setIsLogin( true )
      setIsSubmitting( true )

      const data = {
        hotelId,
        roomId,
        // guest,
        checkInDate,
        checkOutDate,
        paymentMethod: "online",
        paidAmount: 1,
        discountPrice: 0
      }

      const response = await bookProperty(data)
      console.log('>>>>>>>>>', response)

      setRazorpay({ 
        amountToPay: response.amountToPay,
        bookingId: response.bookingId,
        orderId: response.razorpayOrderId
      })

      
    } catch (error) {
      console.log("error", error)
    } finally {
      setIsSubmitting(false)
    }
  }


  return (
    <>
      <Loader loading={isSubmitting}/>
      <MobileHeader gradient={true} height="237px">
        <MobileHeaderSearch text={true} headingtext="Confirm and Pay" />
      </MobileHeader>

      <section className="mobile-top-space">
      <Container>
        <section className="confirm-pay mt-5 pt-3">
          
          <div className="row">
          <div className="col-lg-4 col-md-12 p-0">
              <div className="border border-1 rounded-4 p-3 m-2">
                <h4>Booking Details</h4>
                <div className="my-4" style={{ height: "175px" }}>
                  <img src={ hotel.files?.at(0)?.Url || Hotel} className="w-100 h-100 rounded-4" />
                </div>

                <h5 className="custom-text-color">{ hotel.hotelName }</h5>
                <p className="text-secondary fs-6">
                  <Icon icon={faLocationDot} className="text-saffron me-3" />{" "}
                  { hotel.address }
                </p>

                <div>
                  <h5>Date:</h5>
                  <div className="d-flex justify-content-between">
                    <div>
                      <p className="fs-9 mb-2">Check In</p>
                      <p className="fs-6 mb-2 bold custom-text-color">
                        { dateFormat(checkInDate)}
                      </p>
                    </div>
                    <div>
                      <p className="fs-9 mb-2">Check Out</p>
                      <p className="fs-6 mb-2 bold custom-text-color">
                        { dateFormat(checkOutDate)}
                      </p>
                    </div>
                  </div>
                  <hr />
                </div>

                <div>
                  <h5>Guests:</h5>
                  <div>
                    <p className="fs-9 mb-2">Number of Guests</p>
                    <p className="fs-6 mb-2 bold custom-text-color">
                      { guest }
                    </p>
                  </div>
                  <hr />
                </div>

                <div>
                  <h5>Room:</h5>
                  <div>
                    <p className="fs-9 mb-2">Number of Rooms</p>
                    <p className="fs-6 mb-2 bold custom-text-color">
                      { room.roomCategoryId?.name  }
                    </p>
                  </div>
                  <hr />
                </div>

                <div>
                  <h5>Price details</h5>
                  <div className="d-flex justify-content-between align-items-center">
                    <p className="fs-6 mb-2 bold custom-text-color">
                      ₹{ room.offerPrice || 0 } x { guest } per night
                    </p>
                    <p className="fs-6 mb-2 bold text-saffron">₹{ (room.offerPrice || 0) * guest }</p>
                  </div>
                </div>

                <div className="d-flex justify-content-center">
                  <button className="search-button w-75 my-4" onClick={bookhotel}>
                    Confirm and pay
                  </button>
                </div>
                
              </div>
            </div>            
          </div>

          <div className="row  mx-0 mb-3 mt-5">
            <div className="top-heading mb-3">Best offers for you</div>

          <ul className="list-unstyled d-flex offers-card-list-mobile  mobileScrollBar">
            <li className="m-2">
              <div className="bg-dark rounded offers-card-container">
                <OfferCard data={"Get upto 15% off on your First Booking"} />
              </div>
            </li>

            <li className="m-2">
              <div className="bg-dark rounded offers-card-container">
                <OfferCard data={"Budget Friendly Homestays"} />
              </div>
            </li>
          </ul>

          <div className="col-md-6 d-flex justify-content-center ">
            <button className="w-75 secondary-btn">View All Offers</button>
          </div>
        </div>
        </section>
      </Container>

      {isLogin && <LoginPopup open={isLogin} setOpen={setIsLogin} cb={bookhotel} />}
          <RazorPay amount={razorpay.amountToPay} bookingId={razorpay.bookingId} orderId={razorpay.orderId} customer={customer} cb={(type, response) =>  setRazorpay({}) } />
      </section>
    </>
  );
};

export default ConfirmPay;
